/**
 * Page Boutique View
 */
class PageBoutiqueView {

	constructor(presenter, sectionId) {

		this.parent = $("#shopify-section-" + sectionId);
		this.offsetMargin = this.parent.find(".mon-sticky-offset-margin");
		this.offsetPadding = this.parent.find(".mon-sticky-offset-padding");
		this.presenter = presenter;

		/*
		 * Listeners
		 */

	}

	/*
	 * Actions
	 */

	/*
	 * Getters and Setters
	 */

	setStickyOffset(value) {
		// update the offsets of the positioned elements
		this.offsetMargin.css("margin-top", "-" + value);
		this.offsetPadding.css("padding-top", value);
	}

}